document.addEventListener('click', e => {
  if (e.target.matches('.toggle-desc')) {
    e.preventDefault();
    const btn = e.target;
    const desc = btn.closest('.collection-hero__description');
    desc.classList.toggle('expanded');
    btn.textContent = desc.classList.contains('expanded') ? 'Show less' : 'Show more';
  }
});

window.addEventListener('load', () => {
  document.querySelectorAll('.collection-hero__description').forEach(desc => {
    const link = desc.querySelector('.toggle-desc');
    const text = desc.querySelector('.collection-desc-text');
    if (!link || !text) return;

    const visible = text.clientHeight;
    const total = text.scrollHeight;
    const overflow = total - visible;

    // Only show the link if the content actually overflows
    if (overflow > 50) {
      link.style.display = 'inline-block';
    } else {
      link.style.display = 'none';
    }
  });
});